import { Component } from "@angular/core";

@Component({
    selector: "ifp-callback",
    template: "",
    standalone: false
})
export class CallbackComponent {}
